/* Purpose: Top level navbar for app before a user is signed in
 * Props:
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';



const GuestLayout = () => {
    const lightLogo = require("../Images/windsorLogo.png")
 
    return (
    <>
    <Navbar bg="light" data-bs-theme="light">
      <Container>
        <Navbar.Brand href="/">
                      <img
              src={lightLogo}
              width="100"
              height="40"
              className="d-inline-block align-top"
              alt="Windsor Lending"
            />
        </Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link className = "m5" href="/"><span className = "current-location">Home</span></Nav.Link>
          </Nav>
      </Container>
    </Navbar>
    </>      
    );
}

export default GuestLayout;